export enum Role {
  Doctor = 1,
  Customer = 2,
  Admin = 3,
  Receptionist = 4,
  Watcher = 6,
  HospitalManager = 7,
  OperationManager = 8,
  WhatsappManager = 9,
  PharmacyOperator = 10,
  Pharmacist = 11,
  PharmacyManager = 12,
  Auditor = 13,
  taskReviewer = 14,
  StoreManager = 15,
  IPDPayoutApprover = 16,
  StoreApproval = 17,
  StockTransfer = 18,
  BackdateBillCreator = 19,
  MaximumDiscountOverride = 20,
}
